import gql from 'graphql-tag';

export default gql`
  mutation SignInMutation($input: SignInInput!) @api(name: "auth") {
    signIn(input: $input) {
      token
      user {
        id
        avatar
        username
        email
      }
    }
  }
`;
